import { render } from "./ConfigurationMasterCourses.vue?vue&type=template&id=6646d39d&scoped=true"
import script from "./ConfigurationMasterCourses.vue?vue&type=script&lang=js"
export * from "./ConfigurationMasterCourses.vue?vue&type=script&lang=js"

import "./ConfigurationMasterCourses.vue?vue&type=style&index=0&id=6646d39d&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6646d39d"]])

export default __exports__